/**
 * 面试相关API接口
 */
import request from '@/utils/request'
import type {
  Interview,
  ApiResponse,
  PaginationParams,
  PaginationResponse
} from '@/types/models'

export const interviewApi = {
  /**
   * 获取面试列表
   */
  getInterviewList(params?: PaginationParams & { status?: string; type?: string }) {
    return request<ApiResponse<PaginationResponse<Interview>>>({
      url: '/api2/interviews',
      method: 'get',
      params
    })
  },

  /**
   * 获取面试详情
   */
  getInterviewDetail(id: string) {
    return request<ApiResponse<Interview>>({
      url: `/api2/interviews/${id}`,
      method: 'get'
    })
  },

  /**
   * 参与抽签
   */
  joinLottery(interviewId: string) {
    return request<ApiResponse<{ lotteryNumber: number; lotteryTime: string }>>({
      url: `/api2/interviews/${interviewId}/lottery`,
      method: 'post'
    })
  },

  /**
   * 确认面试时间
   */
  confirmInterview(interviewId: string, datetime: string) {
    return request<ApiResponse<void>>({
      url: `/api2/interviews/${interviewId}/confirm`,
      method: 'post',
      data: { datetime }
    })
  },

  /**
   * 取消面试
   */
  cancelInterview(interviewId: string, reason?: string) {
    return request<ApiResponse<void>>({
      url: `/api2/interviews/${interviewId}/cancel`,
      method: 'post',
      data: { reason }
    })
  },

  /**
   * 获取面试结果
   */
  getInterviewResult(interviewId: string) {
    return request<ApiResponse<{ result: 'pass' | 'fail' | 'pending'; feedback?: string }>>({
      url: `/api2/interviews/${interviewId}/result`,
      method: 'get'
    })
  }
}

export default interviewApi